var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank_box"},[_c('a',{staticClass:"link_elementor",on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._v(" "+_vm._s(_vm.doubleEncodeAndCreateLink(_vm.cellValue))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }